/**
 * --------------------------------------------------------------------------
 * Theme Custom Enhancements
 * --------------------------------------------------------------------------
 * Purpose:
 * - Contains all non-core JS enhancements
 * - Safe to extend without breaking Stretch upgrades
 *
 * Rules:
 * - No direct theme.js modifications
 * - Use data-attributes to scope behavior
 * - Defensive checks only
 * --------------------------------------------------------------------------
 */

document.addEventListener('DOMContentLoaded', () => {
  // Do NOT run custom drag logic on touch devices
  if ('ontouchstart' in window) return;

  initDragScroll('[data-drag-scroll]');
});

/**
 * Enables pointer-based horizontal drag scrolling
 * @param {string} selector
 */
function initDragScroll(selector) {
  document.querySelectorAll(selector).forEach((rail) => {
    let isDown = false;
    let hasDragged = false;
    let startX = 0;
    let scrollLeft = 0;

    rail.addEventListener('mousedown', (e) => {
      isDown = true;
      hasDragged = false;
      startX = e.pageX;
      scrollLeft = rail.scrollLeft;
    });

    rail.addEventListener('mousemove', (e) => {
      if (!isDown) return;

      const walk = e.pageX - startX;

      if (Math.abs(walk) > 5) {
        hasDragged = true;
      }

      rail.scrollLeft = scrollLeft - walk;
      e.preventDefault();
    });

    rail.addEventListener('mouseup', () => {
      isDown = false;
    });

    rail.addEventListener('mouseleave', () => {
      isDown = false;
    });

    // Prevent accidental navigation after drag
    rail.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', (e) => {
        if (hasDragged) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      });
    });
  });
}